import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, useMemo, createElement } from "react";
import routes from "./config";
import { ErrorBoundary } from "@/components/base/ErrorBoundary";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const wrappedRoutes = useMemo(
    () =>
      routes.map((route) => ({
        ...route,
        element: route.element
          ? createElement(ErrorBoundary, null, route.element)
          : undefined,
      })),
    [],
  );

  const element = useRoutes(wrappedRoutes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return element;
}